import React from 'react'
import { Menu, Flex, Button } from 'antd'
import styles from './ft.module.less'
import { UserOutlined, SearchOutlined } from '@ant-design/icons';


export default function MyFooter() {

    return (
        <Flex className={styles.warpper} justify='center'>
            <Flex vertical={false} className={styles.warpper__main} justify='space-between' align='center'>
                <Flex vertical={true}>
                    <Flex className={styles.warpper__main__title}>内容说明</Flex>
                    <Flex className={styles.warpper__main__info}>内容提供：中国科学院文献情报中心科技期刊出版智库团队<br />制作维护：北京智谱华章科技股份有限公司</Flex>
                </Flex>
                <Flex vertical={true}>
                    <Flex className={styles.warpper__main__title}>联系我们</Flex>
                    <Flex className={styles.warpper__main__info}>电话： 010-82626611转6520<br />地址：北京市海淀区北四环西路33号</Flex>
                </Flex>
                <Flex vertical={true}>
                    <Flex className={styles.warpper__main__title}>版权所有</Flex>
                    <Flex className={styles.warpper__main__info}>中国科学院文献情报中心<br />
                        <br />
                        {/* 京ICP备05004093号 京公网安备11010102003195号 */}
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    )
}
